import React from "react";

export default class MissingAPIRouteError extends Error {
	constructor(args) {
		super(args);
		this.ui_message = this.message;
		// Error.captureStackTrace(this, MissingAPIRouteError);
	}
}